import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';

import { Tabs } from 'react-bootstrap';
import TimePickerTab from './TimePickerTab';
import { applyRequiredCapitalizations } from '../../../util/TextUtils';

export default class TimePickerTabs extends Component {
  state = {
    selectedTab: 0,
  };

  render() {
    var { data, zoneId } = this.props,
      tab = [];

    for (let i = 0; i < data.length; i++) {
      let dateArr = data[i],
        label = this.getDateTabTitle(moment(data[i].slots[0]).tz(zoneId));

      tab.push(
        <TimePickerTab
          eventKey={i}
          title={applyRequiredCapitalizations(label)}
          key={i}
          data={dateArr.slots}
          zoneId={zoneId}
          isSelected={i === this.state.selectedTab}
          onChange={this.onRadioSelect.bind(this)}
        />
      );
    }

    return (
      <Tabs activeKey={this.state.selectedTab} id="data-tab" onSelect={this.handleTabSelect.bind(this)}>
        {tab}
      </Tabs>
    );
  }

  handleTabSelect(selectedTab) {
    this.setState({ selectedTab });
  }

  onRadioSelect(selectedTime) {
    var { selectedTab } = this.state;

    this.props.onChange({
      selectedDate: selectedTab,
      selectedTime,
    });
  }

  getDateTabTitle(val) {
    let { zoneId } = this.props;
    // format the date as "ddd - MMM D" and split the date on space
    var value = val.format('ddd - MMM D').split(' ');

    let todayDt = moment()
      .tz(zoneId)
      .date();
    // if the date and month matches for today return "TODAY"
    if (todayDt === value[3] && val.format('MMM') === value[2]) {
      return 'TODAY';
    } else if (todayDt + 1 === value[3] && val.format('MMM') === value[2]) {
      // if the date and month matches for tomorrow then return "TOMORROW"
      return 'TOMORROW';
    } else {
      // return the nexy two days in the "ddd MM/DD" format
      // eg: TUE 8/7
      return value[0].toUpperCase() + ' ' + val.format('M') + '/' + value[3];
    }
  }
}

TimePickerTabs.propTypes = {
  data: PropTypes.array,
  zoneId: PropTypes.string,
  onChange: PropTypes.func,
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/components/common/TimePicker/TimePickerTabs.js